import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <iframe style={{width: "100%", height: "100%"}} src="https://conseder.pythonanywhere.com/" />
  );
}

export default App;
